let reducer_res_utils_counter = 0;

export const reducer_res_get_fresh_key = () => {
  reducer_res_utils_counter++;
  const new_key = reducer_res_utils_counter;
  return new_key;
};

export const reducer_res_create = (reducer_res_key, reducerResponses, note) => {
  // VEROVATNO OVAJ NE TREBA
  // const new_id = reducerResponses.counter + 1;
  const new_promise = {
    reducer_res_key: reducer_res_key,
    note
  };
  return {
    ...reducerResponses,
    items: [...reducerResponses.items, new_promise]
  };
};

export const reducer_res_response_write = (reducer_res_key, reducerResponses, payload) => {
  // reducer write response
  const responded_promise = {
    reducer_res_key,
    responded: true,
    payload: payload
  };
  return {
    ...reducerResponses,
    items: [...reducerResponses.items, responded_promise]
  };
};

export const reducer_res_is_responded = (reducer_res_key, reducerResponses) => {
  let is_responded = false;
  reducerResponses.items.forEach(item => {
    if (item.reducer_res_key === reducer_res_key && item.responded === true) {
      is_responded = true;
    }
  });
  return is_responded;
};